/* assets/customaddons-dev.js

   THIS is the file the live site actually loads. layout/theme.liquid line 3 sets
   `DEBUG_custom_addons = true`, and lines 108 / 272 then load customaddons-dev.js
   INSTEAD of customaddons.js. So customaddons.js is dead code on the published
   theme, and edits to it have no effect.

   Changes from the version dated 31 Jul 2026:

   1. Price roll-up now also counts the spare gliders, so the Add to cart button
      matches what the customer is actually charged. The what's-included block
      publishes its running total on [data-xg-total-cents] and calls
      window.pdUpdatePrices() after every change.
   2. The price-writing half is split out into applyTotals() so it can be
      recalculated without an event object.
   3. DEBUGPRODUCTADDONS off and the four `debugger` statements removed. They
      only bite when devtools is open, but they make the page painful to debug,
      and they are currently live on the shop.
   4. The change handler passes its own `e` rather than relying on the global
      `window.event`, and the two `typeof x !== undefined` tests, which are
      always true, are now real null checks.

   The parent_id syncing on variant change and the per-addon toggling of the
   [data-properties-field] inputs are untouched.
*/

var DEBUGPRODUCTADDONS = false;
/*var addonSelectsContainer = document.getElementById('AddonsContainer'); */
var addonSelects = document.querySelectorAll('[id^=product-addon-]');
var priceElement = document.querySelector('.product-section [data-product-price]');
var atcPriceElement = document.querySelector('product-form [data-button-price]');
var LIPSfieldset = document.getElementById('addons_hidden_line_item_properties');

document.addEventListener('theme:variant:change',(event) => { updatePriceWithAddons(event) } )
addonSelects && addonSelects.forEach( (select) =>  select.addEventListener('change',(e) => { updatePriceWithAddons(e) }) );

/* The spare gliders row keeps its running total in this attribute, on whichever
   element carries it. Returns 0 when the row is absent, so nothing changes on
   templates that do not have it. */
function extraGlidersTotal() {
  var el = document.querySelector('[data-xg-total-cents]');
  if (!el) { return 0; }
  return parseInt(el.getAttribute('data-xg-total-cents'), 10) || 0;
}

/* Entry point for the spare gliders row, which has no event to hand on. */
window.pdUpdatePrices = function () { applyTotals(); };

function updatePriceWithAddons(event) {
  /* triggered by either addon selects changing or variant change */
  var target = event && event.target;

  if (event && event.detail && event.detail.variant) {
    /* update all the addons parent_id inputs to the current variant */
    document.querySelectorAll(`[name$=\\[parent_id\\]]`).forEach( input => { input.value = event.detail.variant.id } );
  }

  if( target && target.tagName == 'SELECT' && target.selectedOptions[0]) {
    if ( target.selectedOptions[0].hasAttribute("data-select-no-addon") ) {
      /* aka target.selectedOptions[0].dataset.selectNoAddon */
      //target.selectedIndex = 0;
      target.options[0].disabled = true;
      document.querySelectorAll(`[data-properties-field=${target.dataset.propertiesFieldSelectorPrefix}]`).forEach( input => {input.disabled = true } );
      /* used to interact with a first <option> as a placeholder that is unselectable(disabled),
        , config in product-addons.liquid snippet with the show_placeholder_first_option AND show_empty_last_option flags
        , which adds a last <option> to represent not selecting anything
        , which in turn this code sets the select to the first <option> as a placeholder with an empty value attribute (show_placeholder_first_option flag)
        , that first <option> otherwise can't be selected by a user because it is disabled.
      */
    } else {
      target.options[0].disabled = false;
      document.querySelectorAll(`[data-properties-field=${target.dataset.propertiesFieldSelectorPrefix}]`).forEach( input => {input.disabled = false } )
    }
  }

  applyTotals();
}

function applyTotals() {
  var priceTotal;
  var addonPriceTotal = 0;

  /* disable fieldset around line-item-property inputs to disable them all if NO addon is selected */
  var anyAddonsSelected = false;
  var selectedAddons = [];
  if (LIPSfieldset) { LIPSfieldset.disabled = true; }

  addonSelects && addonSelects.forEach( (select) =>  {
    if (!select.selectedOptions[0]) { return; }
    if (select.selectedOptions[0].dataset.variantPrice) {
      /* [data-variant-price] has the addons price in the select's option*/
      addonPriceTotal = addonPriceTotal + parseInt(select.selectedOptions[0].dataset.variantPrice);
      // note title from the select value will also have the price in the text
      selectedAddons.push({ "addonTitle":select.selectedOptions[0].dataset.value , "addonPrice":select.selectedOptions[0].dataset.variantPrice });
    }
    if ( select.selectedOptions[0].hasAttribute("value") ) {
      anyAddonsSelected = true;
      if (LIPSfieldset) { LIPSfieldset.disabled = false; }
    }
  });

  if (!priceElement) { return; }

  var currentVariantPrice = parseInt(priceElement.dataset.currentVariantPrice);
  if (parseInt(currentVariantPrice) > 0) {
    /* span[data-product-price] element data current-variant-price price set in theme.js updateProductPrices() during variant selection */
    priceTotal = currentVariantPrice + addonPriceTotal + extraGlidersTotal();
    priceElement.innerHTML = formattingMoney(priceTotal);
    priceElement.dataset.selectedAddons = JSON.stringify(selectedAddons);
    if (atcPriceElement) {
      atcPriceElement.innerHTML = formattingMoney(priceTotal);
    }
  }
}

/* from class ProductForm in theme.dev.js */
/*themeVendor.themeCurrency */
function formattingMoney(money) {
  if (theme.settings.currency_code_enable) {
    return themeVendor.themeCurrency.formatMoney(money, theme.moneyFormat) + ` ${theme.currencyCode}`;
  } else {
    return themeVendor.themeCurrency.formatMoney(money, theme.moneyFormat);
  }
}